import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    accountId: null,
    accountName: null,
    objectType: 'TASK',
    fields: []
};
const taskFieldsSlice = createSlice({
    name: 'taskFields',
    initialState,
    reducers: (create)=>({
            saveFields: create.reducer((state, { payload })=>{
                return {
                    ...state,
                    ...payload
                };
            })
        })
});
export const taskFieldsReducer = taskFieldsSlice.reducer;
export const { saveFields } = taskFieldsSlice.actions;
export const stateName = taskFieldsSlice.name;
